import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const SiteUnitDefaultIcon = ({
  stroke,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M80.7704 59.4209C95.4993 44.692 84.1506 18.9333 63.9999 18.9333C43.8492 18.9333 32.5004 44.692 47.2294 59.4209L62.4433 74.6538C63.3027 75.5143 64.6971 75.5143 65.5565 74.6538L80.7704 59.4209Z"
        stroke={strokeColor}
        strokeWidth="4"
        strokeLinecap="round"
      />
      <circle
        cx="64.0003"
        cy="40.9333"
        r="7.33333"
        stroke={strokeColor}
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M25.8669 71.7333L11.9962 99.4747C11.6305 100.206 12.1623 101.067 12.98 101.067H115.02C115.838 101.067 116.37 100.206 116.004 99.4747L102.134 71.7333"
        stroke={strokeColor}
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
};
